const initialState = {
  colors: [],
};
export default initialState;
